module.exports = __webpack_public_path__ + "img/zidan.293b93f2.png";